import React, { FC, ReactNode } from 'react';
import { Switch } from 'react-router-dom';
import { NotFound } from 'components/NotFound';

const SwitchCatchNotFound: FC<{ children: ReactNode }> = ({ children }) => (
  <Switch>
    {children}
    <NotFound />
  </Switch>
);

export { SwitchCatchNotFound };
